import React from "react";

const HeadingForDashboardReusable = ({ title, description }) => {
  return (
    <div className="ps-1">
      {/* Heading */}
      <div className="flex items-center">
        <div className="rounded-full bg-[color:var(--color-bright)]" />

        <h1 className="text-md font-medium text-slate-600">{title}</h1>
      </div>

      {/* Description */}
      {description && (
        <p className="text-[13px] -mt-1 text-gray-500">{description}</p>
      )}
    </div>
  );
};

export default HeadingForDashboardReusable;
